var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSnsXOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.664 13.856L29.087 2h-2.47l-9.05 10.294L10.337 2H2l10.931 15.567L2 30h2.47l9.558-10.871L21.662 30H30L18.663 13.856zm-3.384 3.848l-1.107-1.55L5.36 3.82h3.794l7.112 9.954 1.108 1.55 9.245 12.94h-3.795l-7.544-10.56z",
    fill: "#000"
  })));
}

export default SvgIconSnsXOutline;